import { render } from "./navigation_pins.vue?vue&type=template&id=a0122606"
import script from "./navigation_pins.js?vue&type=script&lang=js"
export * from "./navigation_pins.js?vue&type=script&lang=js"

import "./navigation_pins.vue?vue&type=style&index=0&id=a0122606&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__